import { createContext, useContext } from 'react';
import { PatientInMeeting } from './transforms';

export type SelectedPatientRow = {
  meetingKey: number;
  patient: PatientInMeeting;
};

export type IDGSelectionContextValue = {
  togglePatientRow: (meetingKey: number, patient: PatientInMeeting) => void;
  isPatientRowSelected: (
    meetingKey: number,
    patient: PatientInMeeting,
  ) => boolean;
};

const noopToggle = (): void => undefined;

export const IDGSelectionContext = createContext<IDGSelectionContextValue>({
  togglePatientRow: noopToggle,
  isPatientRowSelected: () => false,
});

export const useIDGSelection = (): IDGSelectionContextValue =>
  useContext(IDGSelectionContext);
